import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Ambulance, TriangleAlert } from "lucide-react";
import { TerapieBox, TerapieBisognoBox } from "./TerapieCartella";
import { CheckListUnica } from "./TerapieTabellaBox";
import { TerapiaEventoBox } from "./StoricoEventiCartella";
import api from "../lib/api";
import { EVENTO_LABEL } from "../lib/eventiSanitari";

const fD = (iso) => { if (!iso) return ""; const d = new Date(String(iso).length <= 10 ? iso + "T00:00:00" : iso); return isNaN(d) ? iso : d.toLocaleDateString("it-IT"); };
const eta = (dn) => { if (!dn) return null; const d = new Date(dn + "T00:00:00"); if (isNaN(d)) return null; const n = new Date(); let a = n.getFullYear() - d.getFullYear(); if (n < new Date(n.getFullYear(), d.getMonth(), d.getDate())) a--; return a; };
const durata = (di) => { if (!di) return ""; const d = new Date(di + "T00:00:00"); if (isNaN(d)) return ""; const n = new Date(); let m = (n.getFullYear() - d.getFullYear()) * 12 + n.getMonth() - d.getMonth(); if (n.getDate() < d.getDate()) m--; if (m < 1) return "meno di un mese"; const a = Math.floor(m / 12), r = m % 12; return [a ? `${a} ${a === 1 ? "anno" : "anni"}` : "", r ? `${r} ${r === 1 ? "mese" : "mesi"}` : ""].filter(Boolean).join(" e "); };
const tipoTxt = (e) => (e.tipo === "altro" && e.tipo_altro) ? e.tipo_altro : (EVENTO_LABEL[e.tipo] || e.tipo || "Evento");
export const cartellaHelpers = { fD, eta, durata, tipoTxt };

export const useCartellaData = (ospiteId) => useQuery({ queryKey: ["vm-cartella", ospiteId], queryFn: async () => (await api.get("/visite-mediche/cartella", { params: { ospite_id: ospiteId } })).data, refetchInterval: 60000 }).data;

export function EventiChips({ ospiteId }) {
  const data = useCartellaData(ospiteId);
  if (!data) return null;
  return (
    <div className="flex flex-wrap gap-1.5 text-[11px]" data-testid="vm-eventi">
      <span className="inline-flex items-center gap-1 rounded-full bg-white border px-2 py-0.5" data-testid="vm-ricoveri"><Ambulance size={11} /> Ricoveri: {data.ricoveri.length}{data.ricoveri[0] ? ` (ultimo ${fD(data.ricoveri[0].data)})` : ""}</span>
      <span className="inline-flex items-center gap-1 rounded-full bg-white border px-2 py-0.5" data-testid="vm-cadute"><TriangleAlert size={11} /> Cadute: {data.cadute.length}{data.cadute[0] ? ` (ultima ${fD(data.cadute[0].data)})` : ""}</span>
    </div>
  );
}

export function SchedaPaziente({ ospiteId, glic }) {
  const data = useCartellaData(ospiteId);
  if (!data) return <div className="text-xs text-muted-foreground">Caricamento scheda…</div>;
  const ev = data.terapia_evento;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 xl:grid-cols-[1.4fr_1fr] gap-3 items-stretch" data-testid={`vm-terapie-grid-${ospiteId}`}>
        <TerapieBox data={data} ospiteId={ospiteId} glic={glic} />
        <TerapieBisognoBox data={data} ospiteId={ospiteId} />
      </div>
      {ev && <TerapiaEventoBox ev={ev} terapie={data.terapie} ospiteId={ospiteId} structureId={data.ospite?.structure_id} />}
      <CheckListUnica ospiteId={ospiteId} eventoNome={ev ? tipoTxt(ev) : ""} />
    </div>
  );
}
